import upsell from "../upsell"
import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"
import { ensureTrailingSlash } from "../helpers"

const DEFAULT_NUTRITIONIST = "elina"
const NO_NUTRIONIST = "no_coach"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("chat"),

  internalTracker: new TrackingManager(
    window.trackingConfig.enabledTrackingServices,
    pipelineConfig
  ),

  activeNutrionist: DEFAULT_NUTRITIONIST,

  saveSelectedNutrionistInStore(nutrionist) {
    this.store.values.selectedChatNutrionist = nutrionist
  },

  init() {
    this.saveSelectedNutrionistInStore(DEFAULT_NUTRITIONIST)
    this.commonInit()
  },

  handleNutrionistChange(nutrionist) {
    this.internalTracker.trackClick({ clickName: "Expert Selected" })
    this.activeNutrionist = nutrionist
    this.saveSelectedNutrionistInStore(nutrionist)
  },

  async handlePurchase(isModal) {
    this.internalTracker.trackClick({ clickName: "Chat Accepted Clicked" })

    if (isModal) {
      this.saveSelectedNutrionistInStore(DEFAULT_NUTRITIONIST)
      this.purchase()

      return
    }

    // user chose no nutrionist, open modal screen
    if (this.activeNutrionist === NO_NUTRIONIST) {
      const nextStepLink = ensureTrailingSlash(`${pipelineConfig.pathPrefix}${
        pipelineConfig.variants[pipelineConfig.variant].pagePaths["chat-last-chance"]
      }#stored-token=${this.store.values.token}`)
      window.location = nextStepLink

      return
    }

    this.purchase()
  },

  async handleDecline(isModal) {
    this.internalTracker.trackClick({ clickName: "Chat Rejected Clicked" })

    if (!isModal) {
      const nextStepLink = ensureTrailingSlash(
        `${pipelineConfig.pathPrefix}${
          pipelineConfig.variants[pipelineConfig.variant].pagePaths["chat-last-chance"]
        }#stored-token=${this.store.values.token}`
      )
      window.location = nextStepLink

      return
    }

    this.goToNextUpsellOffer(true)
  },

  onInit() {
    this.initUpsell()
  },
})
